import { render, staticRenderFns } from "./postal.vue?vue&type=template&id=4e58ca0f&scoped=true&"
import script from "./postal.vue?vue&type=script&lang=js&"
export * from "./postal.vue?vue&type=script&lang=js&"
import style0 from "./postal.vue?vue&type=style&index=0&id=4e58ca0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e58ca0f",
  null
  
)

export default component.exports